import JSX, { h, Component } from 'preact'
import SearchBox from "../search-box/SearchBox";
import Fetch from "../selector/Fetch";
import Icon from "../assets";
import classNames from "classnames";
interface Props {
  header?: JSX.Element,
  hasSearch?: boolean,
  items?: any[],
  isDynamic?: boolean,
  fetchUrl?: string,
  onLoad?: Function,
  placeholder?: string,
  children: JSX.Element,
  align?: 'right' | 'left'
}

interface State {
  data: any[],
  fetchedItems: any[],
  value?: string
}

class ListSelector extends Component<Props, State> {
  constructor() {
    super();
    this.state = {
      data: [],
      fetchedItems: [],
      value: ''
    }
  }

  render ({ header, hasSearch, items, isDynamic, fetchUrl, onLoad, placeholder, children, align }: Props, { data, value }: State) {
    const filtered = items && items[0].items ?
        [].concat(...items)
            .filter((child: any) => child !== undefined)
            .filter((child: any) => child.items.some((item: { title: string; }) => item.title.toLowerCase().includes(value?.toLowerCase() as string)))
        : items?.filter((item: any) => item.title.toLowerCase().includes(value?.toLowerCase() as string))

    return <div class={classNames('list-selector-wrapper', align && `list-selector-wrapper--align-${align}`)} onClick={e => e.stopPropagation()}>
      <div class='list-selector'>
        { header && header}
      { hasSearch && <SearchBox
          isModerationOverview
          placeholder={placeholder}
          value={value}
          onSubmit={() => {}}
          onInput={(e) => this.setState({value: (e.target as HTMLInputElement).value})}
          onClear={() => this.setState({ value: '' })}
      />}
      {isDynamic ? <Fetch baseUrl={fetchUrl || ''} searchValue={value || ''} onLoaded={onLoad || function() {}}>
        {({loading, items}: { loading: boolean, items: any[] }) => {
          if (loading) return <div className='loader'><Icon icon='animatedLoader'/></div>
          if(!loading && items.length === 0) return <div className='list-selector-no-results'>No results found</div>
          return children[0](items)
        }
        }
      </Fetch> : hasSearch ?
            filtered?.length === 0 ? <div className='list-selector-no-results'>No results found</div> : children[0](filtered)
          : children}
      </div>
    </div>
  }
}

export default ListSelector
